export default __webpack_public_path__ + "static/one-fam-video-poster-b15c9c81148168d92743a26d11f65a72.png";